import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";

import { getGlobalFileUploadConfig } from "@api/applicants/applicantFileUpload";

import { getLastWeekTimestamp } from "@shared/services/date";
import { GlobalFileUploadConfigResponse } from "@shared/services/fileUpload";

export interface GlobalFileUploadConfig extends GlobalFileUploadConfigResponse {
  maxUploadSizeBytes: number;
  uploadPartMaxSizeBytes: number;
}

export const globalFileUploadConfigKeys = {
  all: ["fileUploadConfig"] as const,
};

export function useGlobalFileUploadConfig() {
  const query = useQuery({
    queryKey: globalFileUploadConfigKeys.all,
    queryFn: async () => {
      const { result } = await getGlobalFileUploadConfig();
      return result;
    },
    initialData: {
      maxUploadCountLimit: 0,
      maxUploadLimitMiB: 0,
      uploadPartMaxSizeMiB: 0,
    } satisfies GlobalFileUploadConfigResponse,
    initialDataUpdatedAt: getLastWeekTimestamp,
    select: useCallback(
      (data: GlobalFileUploadConfigResponse): GlobalFileUploadConfig => ({
        ...data,
        maxUploadSizeBytes: data.maxUploadLimitMiB * 1024 ** 2,
        uploadPartMaxSizeBytes: data.uploadPartMaxSizeMiB * 1024 ** 2,
      }),
      [],
    ),
  });

  return query;
}
